<ol *ngIf="cueElement.isNumbered" (sdxInView)="inView = true" [@staggerIn]="inView">
  <li class="stagger-in" *ngFor="let bullet of cueElement.elements; trackBy: trackByFnc">{{bullet.bulletin}}</li>
</ol>

<ul *ngIf="!cueElement.isNumbered" (sdxInView)="inView = true" [@staggerIn]="inView">
  <li class="stagger-in" *ngFor="let bullet of cueElement.elements; trackBy: trackByFnc">{{bullet.bulletin}}</li>
</ul>
